let config = {
    "domain": "http://localhost:8080/app",
    "api_domain": "https://growthify.fly.dev/api",
    "defalut_bearer": "",
    "google_analytics": "UA-213458646-1"
}
export default config